import { Tab } from "@mui/material";
import { ColorsConstants, grayFontColor } from "../cssUtils/constants";
import typography from "../cssUtils/typography";
const DashboardTabLabel = ({ tab, ...props }) => {
  return (
    <Tab
      label={tab}
      {...props}
      sx={{

        ...typography.bodyLarge,
        minHeight: 36,
        py: 1,
        px: 1,
        borderRadius:'8px',
        textTransform: "none", 
        "&.Mui-selected": {
          color: ColorsConstants.primaryWhite,
          backgroundColor: ColorsConstants.primaryPurple100,
        },
        "&:hover": {
         
          transition: "0.3s",
        },
  
        color: grayFontColor
      }}
    />
  );
};

export default DashboardTabLabel;
